import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { getIdeaRequest } from "@microdoing/shared/services/idea/actions";
import { openConversationRequest } from "@microdoing/shared/services/message/actions";
import {
  clearMessageNotifications,
  clickNotification,
} from "@microdoing/shared/services/notification/actions";
import { getPollRequest } from "@microdoing/shared/services/poll/actions";
import { getSurveyRequest } from "@microdoing/shared/services/survey/actions";
import {
  selectReviewFromFeedbackId,
  selectReviewFromStepId,
} from "@microdoing/shared/services/userCampaign/actions";
import { Dispatch } from "react";

interface IRedirectNavigationProps {
  event?: string;
  type: string;
  _id?: string;
  userId: string;
  dispatch: Dispatch<any>;
}
const redirectNavigation = ({
  event = "",
  type = "",
  _id = "",
  userId = "",
  dispatch,
}: IRedirectNavigationProps) => {
  const navigateToEvent = () => {
    let navigationRoute = "";
    let navigationParams = {};

    if (type === "pulse") {
      dispatch(requestExternalUser({ userId: event }));
    } else if (type === "idea-comment") {
      dispatch(getIdeaRequest({ ideaId: event }));
    } else if (type === "randomCoffee") {
      navigationRoute = "RandomCoffee";
    } else if (type === "poll") {
      dispatch(getPollRequest(event));
      navigationRoute = "Poll";
    } else if (type === "survey") {
      dispatch(getSurveyRequest({ surveyId: event }));
      navigationRoute = "Survey";
    } else if (type === "coaching") {
      // navigationRoute = "Coaching";
    } else if (type === "resource") {
      navigationRoute = "Library";
    } else if (type === "review") {
      dispatch(selectReviewFromFeedbackId(event));
    } else if (type === "message") {
      dispatch(clearMessageNotifications());
      dispatch(
        openConversationRequest({
          receivers: JSON.parse(event),
          conversationId: _id,
        }),
      );
      navigationRoute = "Chat";
    } else if (type === "stepComment" || type === "stepCommentLike") {
      // ? event is the stepId of the step
      dispatch(selectReviewFromStepId(event));
    }

    if (type !== "message") {
      dispatch(
        clickNotification({
          notificationId: _id,
          userId: userId,
        }),
      );
    }

    return { navigationRoute, navigationParams };
  };

  return navigateToEvent();
};

export default redirectNavigation;
